<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAccountOff } from "@mdi/js";
export default {
  name: "MdiAccount",
  data() {
    return {
      svgPath: mdiAccountOff,
    };
  },
};
</script>
